/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casenotfound2Inputs */

const en_casenotfound2 = /** @type {(inputs: Casenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case not found.`)
};

const pt_casenotfound2 = /** @type {(inputs: Casenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso não encontrado.`)
};

/**
* | output |
* | --- |
* | "Case not found." |
*
* @param {Casenotfound2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casenotfound2 = /** @type {((inputs?: Casenotfound2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casenotfound2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casenotfound2(inputs)
	return pt_casenotfound2(inputs)
});
export { casenotfound2 as "caseNotFound" }